import {store} from '@/store';

export const isAuthenticated = () => {
  const { user, authenticated } = store.state.auth;
  return !!authenticated && typeof user === 'object' && Object.keys(user).length > 0;
}
